import 'promise-polyfill';
import 'whatwg-fetch';
import MobileMenu from './modules/MobileMenu';
import StickyHeader from './modules/StickyHeader';

MobileMenu();
StickyHeader();
